<template>
  <!-- 答题须知 -->
  <div>
    <div class="headbt">
      <span class="zjt" @click="fh"><img src="../../assets/img/zjt.png" ></span>答题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>



  <!-- 开始答题 -->
<!--  <el-card class="box-card"> -->
<div class="cards_a" v-if="jzwc == 1">
    <div class="rw-info">
      <div class="rw-flag"></div>
      <div class="rw-title">{{title}}</div>

    </div>
    <div class="content">
      <div class="wt-box">
        <!-- <div class="wt-title">{{index+1}}、{{list[index].subject}}</div> -->
        <div class="wt-title">{{index+1}}、{{list[index].subject == undefined ?'': list[index].subject}}</div>
        <div class="wt-jsjs">
          <div>已答：<span style="color: red;">{{askindex}}</span>/{{total}}</div>
          <div>用时：<span style="color: rgb(21, 183, 185);">{{yongshi}}</span></div>
        </div>
      </div>
      <el-progress :percentage="jdt" :show-text="false"></el-progress>
      <div class="lb-optons-box">
        <div class="lb-optons-hr">
          <div class="lb-optons-left">选项</div>
          <div class="lb-optons-right">
            <div class="lb-optons-right-item">M</div>
            <div class="lb-optons-right-item">L</div>
          </div>
        </div>
        <div class="lb-optons" v-for="(item,index2) in list[index].options" :key="index2">
          <div class="lb-optons-left">{{item.key}}</div>
          <div class="lb-optons-right">
            <div class="lb-optons-right-item"><el-radio name="M" v-model="valueM" :label="item.M" :disabled="valueL.slice(-1) == item.M.slice(-1)" @change="answer">{{item.M.slice(0,1)}}</el-radio></div>
            <div class="lb-optons-right-item"><el-radio name="L" v-model="valueL" :label="item.L" :disabled="valueM.slice(-1) == item.L.slice(-1)" @change="answer">{{item.L.slice(0,1)}}</el-radio></div>
          </div>
        </div>
      </div>
      <div>
        <el-button class="next-btn" :class="[this.index == 0?'jy_class':'']" type="primary" size="mini" @click="up">上一题</el-button>
        <el-button class="next-btn" :class="[this.index == total-1?'jy_class':'']" type="primary" size="mini" @click="down">下一题</el-button>
        <el-button class="next-btn" type="primary" size="mini" @click="subjg" v-show="askindex == total">提交评测结果</el-button>
      </div>
      <div style="margin-top: 30px;margin-left: 30px;"><el-checkbox v-model="next_auto" :true-label="1" :false-label="0">答完自动下一题</el-checkbox></div>
      <div>
        <div style="font-weight: bold;font-size: 16px;padding-left: 10px;margin-top: 20px;margin-bottom: 20px;">已答题预览:</div>
        <div class="ydtyl">
          <div class="ydtyl-item" :class="active_color(index)" v-for="(item,index) in list" :key="index" @click="change_item(index)">{{index+1}}</div>
        </div>
      </div>
    </div>
<!--  </el-card> -->
</div>
   </div>
</template>

<script>
  import { lbdetailedList1,dati1 } from '../../api/baseset.js'
  export default {
    data() {
      return {
        step: 0,
        rwinfo: {},
        lbinfo: {},
        list: [{subject:''}],
        askindex: 0,
        index: 0,
        total: 0,
        time: 0,
        valueM: '',
        valueL: '',
        next_auto: 1,
        jglist: [],
        jglabs: [],
        title:'',
        taskid:'',
        lbid:'',
        jzwc:0
      }
    },
    created() {
      this.init();
      //this.lbinfo = 'b2daf3519c1d4af0a8d4abc1730b6e12';
      //this.getData();
    },
    computed: {
      yongshi() {
        var minutes = Math.floor((this.time % 3600) / 60);
        var seconds = this.time % 60;
        if(minutes < 10) {
          minutes = '0'+minutes;
        }
        if(seconds < 10) {
          seconds = '0'+seconds;
        }
        return minutes+':'+seconds;
      },
      jdt() {
        if(this.total > 0){
          return (this.askindex/this.total).toFixed(2) * 100;
        }else{
          return 0;
        }
      }
    },
    methods:{
      init() {

         let cache = JSON.parse(localStorage.getItem('profileData'))

         this.taskid =cache.rwid
         this.lbid =cache.lbid
         this.title = cache.title
          let datiinfo = localStorage.getItem(this.taskid+"_"+this.lbid+"_"+"datiinfo");

        if(datiinfo ){

          datiinfo = JSON.parse(datiinfo);
          this.step = datiinfo.step;
          this.rwinfo = datiinfo.rwinfo;
          this.lbinfo = datiinfo.lbinfo;
          this.list = datiinfo.list;
          this.askindex = datiinfo.askindex;
          this.index = datiinfo.index;
          this.total = datiinfo.total;
          this.time = datiinfo.time;
          this.valueM = datiinfo.valueM;
          this.valueL = datiinfo.valueL;
          this.next_auto = datiinfo.next_auto;
          this.jglist = datiinfo.jglist;
          this.jzwc = 1;
           this.jglabs = JSON.parse(localStorage.getItem(this.taskid+"_"+this.lbid+"_"+"jglabs"));
          this.jishi();
        }else{


          this.getData(cache.lbid);
          this.jishi();
        }

      },
      getData(id) {
        let that = this;
        lbdetailedList1({gaugeId:id}).then(res => {

          if(res.code = 200) {
            that.list = res.data;
            that.total = res.data.length;
          }
        })

        this.jzwc = 1;
      },
      jishi(){
        let that = this;
        setInterval(function(){
          that.time++;
        },1000);
      },
      ksdt() {
        this.step = 1;
        this.jishi();
      },
      back() {
        this.$router.go(-1);
      },
      answer() {
        if(this.next_auto == 1){
          this.wthd();
          let that = this;
          setTimeout(function(){
            that.down();
          },200);
        }else{

          this.wthd();
        }
      },
      wthd() {


        if(this.valueM !== '' && this.valueL !== ''){
          let value = {M:this.valueM,L:this.valueL};
          if(this.jglist.length <= this.total){
            this.jglist[this.index] = value;
            let labs = {};
            for(let i=0;i<this.list[this.index].options.length;i++){
              if(this.list[this.index].options[i].M == this.valueM){
                labs.M = this.list[this.index].options[i].key;
              }
              if(this.list[this.index].options[i].L == this.valueL){
                labs.L = this.list[this.index].options[i].key;
              }
            }

            this.jglabs.slice(this.index,1)

            this.jglabs[this.index] = labs;

            this.askindex = this.jglist.length;

            this.cache();
          }
        }
      },
      cache() {
        localStorage.setItem(this.taskid+"_"+this.lbid+"_"+"datiinfo", JSON.stringify(this.$data));
        localStorage.setItem(this.taskid+"_"+this.lbid+"_"+"jglabs",JSON.stringify(this.jglabs));

      },
      up() {
        if(this.index > 0){
          this.index--;
          if(this.jglist[this.index] == undefined){
            this.valueM = '';
            this.valueL ='';
          }else{
            let value = this.jglist[this.index];
            this.valueM = value.M;
            this.valueL = value.L;
          }
        }
      },
      down() {
        if(this.index < this.total - 1 && this.index < this.askindex){
          this.index++;
          if(this.jglist[this.index] == undefined){
            this.valueM = '';
            this.valueL ='';
          }else{
            let value = this.jglist[this.index];
            this.valueM = value.M;
            this.valueL = value.L;
          }
        }
      },
      active_color(num){
        if(num == this.askindex){
          return 'dq_state';
        }else if(num < this.askindex){
          return 'yd_state';
        }else{
          return '';
        }
      },
      change_item(index){
        if(index <= this.askindex){
          this.index = index;
          if(this.jglist[this.index] == undefined){
            this.valueM = '';
            this.valueL ='';
          }else{
            let value = this.jglist[this.index];
            this.valueM = value.M;
            this.valueL = value.L;
          }
        }
      },
      subjg() {
        localStorage.removeItem(this.taskid+"_"+this.lbid+"_"+'datiinfo');
        localStorage.removeItem(this.taskid+"_"+this.lbid+"_"+'jglabs');
        //return
        let param = []

        for(let i=0;i<this.list.length;i++){
          let hdm = {taskId:this.taskid,option: this.jglabs[i].M,optionValue:this.jglist[i].M.slice(0,1),gaugeId:this.lbid,detailedId:this.list[i].id,optionValueType:1}
          let hdl = {taskId:this.taskid,option: this.jglabs[i].L,optionValue:this.jglist[i].L.slice(0,1),gaugeId:this.lbid,detailedId:this.list[i].id,optionValueType:2}
          param.push(hdm);
          param.push(hdl);
        }

        let that = this;

        dati1(param).then(res => {
          if(res.code == 200){
            that.$message({
              type: 'success',
              message: '提交成功'
            });
           // that.$router.go(-1);
           this.$router.push("/user/wdcpdetail1/"+this.lbid+'/'+this.taskid+"/"+this.title);
           // this.$router.replace("/user/wdcpdetail1/"+this.lbid+'/'+this.rw.taskId);
          }else{
            that.$message.error(res.msg);
          }
        })
      },
      fh(){
        //clearInterval(intervalId);
       window.history.go(-1);
      },
    }
  }
</script>

<style scoped>
  .el-card__body{
    border: solid 1px green !important;
  }
  .box-card{width: 96%;margin: auto;}
  .rw-info{display: flex;font-size: 15px;}
  /* .rw-flag{width: 6px;height: 21px;border-radius: 3px;background-color: #15b7b9;margin-right: 10px;margin-top: 14px;}
  .rw-title{width: 90%;overflow: hidden;color: black;font-size: 14px;height: 45px;line-height:45px;font-weight: bold;} */
  .rw-flag{width: 5px;height: 25px;border-radius: 3px;background-color: #00DDA3;margin-right: 10px;margin-top: 14px;}
  .rw-title{width: 65%;margin-top:14px;line-height: 24px;font-size: 14px;font-weight: bold;color: black;}
  .rw-back{width: 7%;color: #00DDA3;text-align: right;}
  .tip{font-size: 14px;color: #333;}
  .rw_disc{color: #666;margin-top: 20px;font-size: 14px;line-height: 26px;}
  .container {display: flex;justify-content: center;margin-top: 100px;}
  .content{min-height: 400px;font-size: 14px;color: #333;border: solid 1px #ddd;width: 100%; }
  .wt-box{height: 60px;background-color: aliceblue;font-size: 14px;display: flex;}
  .wt-title{width: 65%;line-height: 60px;font-size: 18px;text-indent: 15px;}
  .wt-jsjs{width: 30%;line-height: 30px;}
  .wt-option{margin-top: 30px;font-size: 14px;padding-left: 30px;}
  .next-btn{margin-top: 50px;margin-left: 30px;}
  .ydtyl{display: flex;flex-wrap: wrap;}
  .ydtyl-item{width: 22px;height: 22px;line-height: 22px;border-radius: 3px;background-color: #999;margin-left: 5px;text-align: center;color: #ffffff;margin-bottom: 5px;cursor: pointer;}
  .yd_state{background-color: #00DDA3;}
  .dq_state{background-color: #ffae3b;}
  .jy_class{background-color: #999!important;border: #999!important;}
  /deep/ .el-radio__label{font-size: 14px;}
  /deep/ .el-progress-bar__inner{background-color: #00DDA3;}
  /deep/ .el-button--primary{background-color: #00DDA3;border: #00DDA3;}

  .lb-optons-box{width: 96%;margin: 20px auto;border: solid 1px #ddd;}
  .lb-optons-hr{width: 100%;display: flex;line-height: 40px;font-weight: bold;border-bottom: solid 1px #ddd;}
  .lb-optons{width: 100%;display: flex;line-height: 40px;}
  .lb-optons-left{width: 65%;border-right: solid 1px #ddd;text-indent: 10px;}
  .lb-optons-right{width: 30%;display: flex;}
  .lb-optons-right-item{width: 50%;text-align: center;}
  .cards_a{padding: 5px;background-color: white;margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/user/datia.vue